import React, { useState, useEffect } from 'react'
import LoginHeader from '../Login_header'
import Menu from '../Menu'
import { Container, Row, Col, Form, Button, Table, Badge, Modal, Tabs, Tab } from 'react-bootstrap'
import LocationSelector from '../LocationSelector';
import { useNavigate } from 'react-router-dom';
import * as Common from "../Common";
import * as Picklist from "../Picklist";
import DatePicker from 'react-datepicker';
import AsyncSelect from 'react-select/async';
import Dialog from '../Dialog';
import $ from 'jquery';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogYesNo from '../Dialog_Yes_No';
import ActivityLog from '../ActivityLog';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';

const Fund_transfer = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBoxUploadYN, setMsgBoxUploadYN] = useState(false);
    const [msgTextUploadYN, setMsgTextUploadYN] = useState("");
    //--------------------------------------------------------------------
    const [checkerApprovalRight, setCheckerApprovalRight] = useState([]);
    const [bMApprovalRight, setBMApprovalRight] = useState([]);
    const [zMApprovalRight, setZMApprovalRight] = useState([]);
    const [coApprovalRight, setCOApprovalRight] = useState([]);
    const [amApprovalRight, setAMApprovalRight] = useState([]);
    const [cfoApprovalRight, setCFOApprovalRight] = useState([]);

    //--------------------------------------------------------------------
    const [filterLocation, setFilterLocation] = useState('A');
    const [ftLocation, setFtLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0)
    const [filterFromSrno, setFilterFromSrno] = useState("");
    const [filterToSrno, setFilterToSrno] = useState("");
    const [filterFromDate, setFilterFromDate] = useState(new Date());
    const [filterToDate, setFilterToDate] = useState(new Date());
    const [filterStatus, setFilterStatus] = useState("MK");
    const [isDownload, setIsDownload] = useState(true);
    const [allChecked, setAllChecked] = useState(false);

    const [radioType, setRadioType] = useState("St");
    const [scrMode, setScrMode] = useState("");

    const [fundData, setFundData] = useState([]);

    // ------------------------------------------------------------------
    const [hdrLocation, setHdrLocation] = useState("");
    const [hdrAmount, setHdrAmount] = useState("");
    const [hdrType, setHdrType] = useState("");
    const [hdrSrno, setHdrSrno] = useState("");
    const [hdrDate, setHdrDate] = useState(new Date());
    const [ldgAllBank, setLdgAllBank] = useState(null);
    const [ldgAllBankCode, setLdgAllBankCode] = useState("");
    const [nGroup, setNGroup] = useState("");
    const [nAccount, setNAccount] = useState("");
    const [nAccountNo, setNAccountNo] = useState("");
    const [nIfscCode, setNIfscCode] = useState("");

    const [requireApprovalOf, setRequireApprovalOf] = useState("");
    const [isDownloadBankFile, setIsDownloadBankFile] = useState("");
    const [statusApprovedPending, setStatusApprovedPending] = useState("P");

    //-------------------------------------------------------------
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [viewDate, setViewDate] = useState('');
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [filterTranType, setFilterTranType] = useState("PB");
    //------------------------------------------------------------
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [tpBankData, setTPBankData] = useState([]);
    const [bankDetail, setBankDetail] = useState();
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [showUploadDownloadModal, setShowUploadDownloadModal] = useState(false);
    const [lastApproval, setLastApproval] = useState("");
    const [userUploadRight, setUserUploadRight] = useState([]);
    const [userUpdateBankDetailRight, setUserUpdateBankDetailRight] = useState([]);
    const [userDownloadRight, setUserDownloadRight] = useState([]);
    const [showUploadButton, setShowUploadButton] = useState(false);
    const [nFile, setNFile] = useState("");
    const [nFileUploadDocument, setNFileUploadDocument] = useState("");
    const [locationName, setLocationName] = useState("");
    const [refNum, setRefnum] = useState("");
    const [gbNumber, setGbNumber] = useState("");
    const [faNumber, setFaNumber] = useState("");
    const [searchFilter, setSearchFilter] = useState("");
    const [pProductList, setPProductList] = useState([]);
    const [key, setKey] = useState("INFO");
    const [filterBankName, setFilterBankName] = useState("AXIS");
    const [ledgerName, setLedgerName] = useState("");
    const [filterUploadDocType, setFilterUploadDocType] = useState([]);
    const [filterUploadDocCode, setFilterUploadDocCode] = useState(0);
    const [uploadedDocList, setUploadedDocList] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [acRemark, setAcRemark] = useState("");
    const [userDocUploadRight, setUserDocUploadRight] = useState([]);
    const [fullRefno, setFullRefno] = useState("");
    const [fullRefnoTimestamp, setFullRefnoTimestamp] = useState("");
    const [refUpdatedSrno, setRefUpdatedSrno] = useState("");
    const [isRefUpdated, setIsRefUpdated] = useState("");
    const [isEditable, setIsEditable] = useState("N");
    const [isexport, setExport] = useState("0");
    const [showRejectButton, setShowRejectButton] = useState("0");
    const [filterBankType, setFilterBankType] = useState("");
    const [filterBankSrno, setFilterBankSrno] = useState("");
    const [filterbanklocation, setFilterBankLocation] = useState("");
    const [confirmResolve, setConfirmResolve] = useState(null);
    const [payingToId, setpayingToId] = useState(null);
    const [payingToName, setpayingToName] = useState(null);
    let sessionUserId = sessionStorage.userSrno;
    const [piFundProcess, setPiFundProcess] = useState([]);
    const [rightCkPi, setRightCkPi] = useState([]);
    const [rightZmPi, setRightZmPi] = useState([]);
    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'FUND_TRANSFER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiAWS, [sid, "filename", 'FT'], result => {
                        setDocumentList(JSON.parse(result));
                    });
                    Promise.all([
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_CHECKER_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_BM_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_ZM_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_CO_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_CFO_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_DOWNLOAD']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_UPLOAD']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_DOC_UPLOAD']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_UPDATE_BANK_DETAIL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_AM_APPROVAL']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'PI_FUND_PROCESS']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_CK_APPROVAL_PI']),
                        Common.callApiPromise(Common.apiRight, [sid, 'all', 'FUND_TRANSFER_ZM_APPROVAL_PI']),
                    ])
                        .then(([ckResp, bmResp, zmResp, coResp, cfoResp, downloadright, uploadright, uploaddocright, updatebankdetail, amResp, pi_fund,approvel_ck_pi,approvel_zm_pi]) => {
                            setCheckerApprovalRight(ckResp);
                            setBMApprovalRight(bmResp);
                            setZMApprovalRight(zmResp);
                            setCOApprovalRight(coResp);
                            setCFOApprovalRight(cfoResp);
                            setCFOApprovalRight(cfoResp);
                            setUserDownloadRight(downloadright);
                            setUserUploadRight(uploadright);
                            setUserDocUploadRight(uploaddocright);
                            setUserUpdateBankDetailRight(updatebankdetail);
                            setAMApprovalRight(amResp);
                            setPiFundProcess(pi_fund)
                            setRightCkPi(approvel_ck_pi)
                            setRightZmPi(approvel_zm_pi)
                            if (ckResp.query === "1") setFilterStatus('MK');
                            if (bmResp.query === "1") setFilterStatus('CK');
                            if (amResp.query === "1") setFilterStatus('BM');
                            if (zmResp.query === "1") setFilterStatus('AM');
                            if (coResp.query === "1") setFilterStatus('ZM');
                            if (cfoResp.query === "1") setFilterStatus('CO');
                        })
                        .catch(error => alert(error));
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);
    const handleChangeRepLocation = (value) => {
        console.log("This is Picklist Location!", value);
        setFtLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
    }
    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            setMsgBoxYN(false);
            setScrMode("");
        }
    }
    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }
    const listFundData = () => {
        var msg = [], i = 0;
        if ((radioType === "S" && (filterFromSrno === "" || filterToSrno === ""))) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((radioType === "S" && (filterFromSrno === "" || filterToSrno === "")) ? "Select From and To Srno" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $(".loader").show();
            const obj = {
                filterLocation: filterLocation,
                locationCode: locationCode,
                radioType: radioType,
                filterFromSrno: filterFromSrno,
                filterToSrno: filterToSrno,
                filterFromDate: Common.dateYMD(filterFromDate),
                filterToDate: Common.dateYMD(filterToDate),
                filterTranType: filterTranType,
                filterStatus: filterStatus,
                searchFilter: searchFilter
            }
            Common.callApi(Common.apiFundTransfer, [sid, "getlist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setFundData(JSON.parse(result).resarray);
                setIsDownload(true);
                setTPBankData([]);
                setTranAuditTrail([]);
            });
        }

    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            location: resp.tft_location,
            type: resp.type,
            srno: resp.srno,
            group: resp.group,
            account: resp.account,
            bankCode: resp.accountcode,
            accnum: resp.accountno,
            ifsc: resp.accountifsc,
        };
        setCompareData([obj2]);
    }
    const fillViewForm = (item) => {
        $(".loader").show();
        setTPBankData([]);
        setViewDate(item.tft_date);
        const obj = {
            location: item.tft_location,
            type: item.tft_type,
            srno: item.tft_srno
        }
        Common.callApi(Common.apiFundTransfer, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            fillViewCompareObject(resp);
            setScrMode("Q");
            setHdrLocation(resp.location);
            setHdrType(resp.type);
            setHdrSrno(resp.srno);
            getUploadedDoc(`transaction/${resp.location}-${resp.type}-${resp.srno}`);
            setHdrDate(new Date(resp.tft_date).toLocaleDateString());
            setHdrAmount(resp.forextotal);
            if (resp.accountcode == '0' || resp.accountcode == "") setLdgAllBank(null);
            else setLdgAllBank({ id: '^' + resp.accountcode + '^' + resp.bank_name + '^', label: resp.accountcode + ' ' + resp.bank_name });
            setLdgAllBankCode(resp.accountcode);
            setNGroup(resp.group);
            setNAccount(resp.account);
            setNAccountNo(resp.accountno);
            setNIfscCode(resp.accountifsc);
            setRequireApprovalOf(resp.requiredApproval);
            setIsDownloadBankFile(resp.isDownloadBankFile);
            setStatusApprovedPending(resp.statusApprovedPending);
            setLastApproval(resp.lastapproval);
            setLocationName(resp.locationname);
            setRefnum(resp.tft_ref_no);
            setGbNumber(resp.gbno);
            setFaNumber(resp.fano);
            setPProductList(resp.productlist);
            setLedgerName(resp.ledgername);
            setFullRefno(resp.fullrefno);
            setFullRefnoTimestamp(resp.fullrefnotimestamp);
            setRefUpdatedSrno(resp.updatedreflinksrno);
            setIsRefUpdated(resp.isrefupdated);
            setIsEditable(resp.iseditable);
            setExport(resp.tft_export);
            setShowRejectButton(resp.showrejectbutton);
            setTPBankData([
                ...tpBankData,
                {
                    tft_group: resp.group, tft_account: resp.account, tft_amount: resp.forextotal, tft_srno: resp.srno
                    , tft_location: resp.location, tft_type: resp.type, tft_date: resp.tft_date
                    , tft_ref_no: resp.tft_ref_no, tft_single_download: "1"
                }
            ]);
            if (resp.type === 'PI') {
                if (resp.tp_account_type === 'PARTY') {
                    setpayingToName(resp.ledgername)
                    setpayingToId(resp.account)
                }
                else {
                    setpayingToName(resp.me_employee)
                    setpayingToId(resp.tp_executive_id)
                }
            }

            if (resp.type === 'PP') {
                setpayingToName(resp.hdr_individual_name)
                setpayingToId(resp.hdr_individual)
            }

            if (resp.type === 'PB') {
                setpayingToName(resp.ledgername)
                setpayingToId(resp.account)
            }

            $(".loader").hide();
        });
    }
    const handleAllBankChange = (value) => {
        setLdgAllBank(value);
        const allbank = value.id.split('^');
        setLdgAllBankCode(allbank[1]);
    }
    const handleSendBacktobranch = () => {

        const obj = {
            updatedStatus: requireApprovalOf,
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno
        }
        //--------CURRENTLY OBJ NOT USED IN BACKEND 
        Common.callApi(Common.apiFundTransfer, [sid, "sendbackfund", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setScrMode("");
            if (resp.response === "1") {
                setMsgText("Send back to branch Successfully ✅");
                setMsgBox(true);
            } else {
                setMsgText("Failed to Send");
                setMsgBox(true);
            }
            listFundData();
        });
    }
    const handleRejectFund = () => {
        const obj = {
            updatedStatus: requireApprovalOf,
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno
        }
        //--------CURRENTLY OBJ NOT USED IN BACKEND 
        Common.callApi(Common.apiFundTransfer, [sid, "rejectfund", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setScrMode("");
            if (resp.response === "1") {
                setMsgText("Reject Successfully ✅");
                setMsgBox(true);
            } else {
                setMsgText("Failed to Reject");
                setMsgBox(true);
            }
            listFundData();
        });
    }
    const updateBankDetails = () => {
        $(".loader").show();
        var msg = [], i = 0;
        const obj = {
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno
        }
        Common.callApi(Common.apiFundTransfer, [sid, "updatebankdetails", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setScrMode("");
            if (resp.response === "1") {
                setMsgText("Updated Successfully ✅");
                setMsgBox(true);
            } else {
                setMsgText("Failed to Update");
                setMsgBox(true);
            }
            listFundData();
        });
    }

    const showConfirm = (message) => {
        setMsgTextYN(message);
        setMsgBoxYN(true);

        return new Promise((resolve) => {
            setConfirmResolve(() => resolve);
        });
    };

    const handleYes = () => {
        setMsgBoxYN(false);
        if (confirmResolve) confirmResolve(true);
    };

    const handleNo = () => {
        setMsgBoxYN(false);
        if (confirmResolve) confirmResolve(false);
    };

    const handleApproveFund = async () => {
        let confirmApprove = await showConfirm("Are you sure you want to approve?");
        if (!confirmApprove) return;
        $(".loader").show();
        var msg = [], i = 0;
        if (ldgAllBankCode === "" || nAccountNo === "" || nIfscCode === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ldgAllBankCode === "" ? " Bank name . " : '');
            msg[i++] = (nAccountNo === "" ? "Account Number ." : '');
            msg[i++] = (nIfscCode === "" ? "IFSC Code . " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                updatedStatus: requireApprovalOf,
                location: hdrLocation,
                type: hdrType,
                srno: hdrSrno,
                amount: hdrAmount
            }
            Common.callApi(Common.apiFundTransfer, [sid, "approvefund", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setScrMode("");
                if (resp.response === "1") {
                    setMsgText("Approved Successfully ✅");
                    setMsgBox(true);
                } else {
                    setMsgText("Failed to Approve");
                    setMsgBox(true);
                }
                listFundData();
            });
        }
    }
    const handleExportFund = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (ldgAllBankCode === "" || nAccountNo === "" || nIfscCode === "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ldgAllBankCode === "" ? " Bank name . " : '');
            msg[i++] = (nAccountNo === "" ? "Account Number ." : '');
            msg[i++] = (nIfscCode === "" ? "IFSC Code . " : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            $(".loader").hide();
        } else {
            const obj = {
                updatedStatus: requireApprovalOf,
                location: hdrLocation,
                type: hdrType,
                srno: hdrSrno,
                amount: hdrAmount
            }
            Common.callApi(Common.apiFundTransfer, [sid, "exportfund", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setScrMode("");
                if (resp.response === "1") {
                    setMsgText("Exported Successfully ✅");
                    setMsgBox(true);
                } else {
                    setMsgText("Failed to Approve");
                    setMsgBox(true);
                }
                listFundData();
            });
        }
    }
    const btnEditRequest = () => {
        setScrMode('E');
    }
    const saveData = () => {
        const obj = {
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno,
            group: nGroup,
            account: nAccount,
            bankCode: ldgAllBankCode,
            accnum: nAccountNo,
            ifsc: nIfscCode,
        }
        const infoObject = Common.compareArrays(compareData, [obj]);

        if (userRight.edit === "1" && scrMode === "E") {
            setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, "MVLGD", "0"));
        }
        Common.callApi(Common.apiFundTransfer, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
            let resp = JSON.parse(result);
            setScrMode("");
            if (resp.response === "1") {
                setMsgText("Updated Successfully ✅");
                setMsgBox(true);
            } else {
                setMsgText("Updation Failed");
                setMsgBox(true);
            }
            listFundData();
        });
    }
    const downloadBankFile = () => {
        $(".loader").show();
        if (tpBankData.length === 0) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText('Please select at least one record');
        }
        if (!bankDetail) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText('Please select at least one Bank');
        }
        else if (!bankDetail) {
            $(".loader").hide();
            setMsgText('Please select from bank');
            setMsgBox(true);
        }
        // else if (bank[7] !== 'AXIS') {
        //     setShowDownloadModal(false);
        //     setMsgText(`You can't download any other than Axis bank files `);
        //     setMsgBox(true);
        // }
        else {
            const bank = bankDetail.id.split('^');
            console.log(bank);
            const obj = {
                tpBankData: tpBankData,
                tmp_from_bank_group: bank[1],
                tmp_from_bank_account: bank[2],
                tmp_account_number: bank[5],
                tmp_account_name: bank[3],
                tmp_ifdc: bank[6],
                tmp_bank_code: bank[7],
                filterLocation: filterLocation,
                locationCode: locationCode,
                radioType: radioType,
                filterFromSrno: filterFromSrno,
                filterToSrno: filterToSrno,
                filterFromDate: Common.dateYMD(filterFromDate),
                filterToDate: Common.dateYMD(filterToDate),
                filterTranType: filterTranType,
                filterStatus: filterStatus
            };
            Common.callApi(Common.apiFundTransfer, [sid, "checkBankSelected", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                setScrMode("");
                if (resp.status) {
                    Common.callDownloadApiPost1(Common.apiFundTransfer, "post", [sid, 'downloadbankfile', JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setShowDownloadModal(false);
                        setIsDownload(false);
                        setFundData([]);
                    });
                } else {
                    $(".loader").hide();
                    setMsgText(resp?.msg);
                    setMsgBox(true);
                }
            });
        }
    };
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: hdrType, trannumber: hdrSrno, trancategory: "T", location: hdrLocation });
    }
    const handleStatus = (e) => {
        setFilterStatus(e.target.value);
        setFundData([]);
    }
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setAllChecked(isChecked);

        // Update tpModuleData to reflect the "Select All" checkbox change
        const updatedModuleData = fundData.map(item => ({
            ...item,
            ischecked: isChecked ? '1' : '0'
        }));

        setFundData(updatedModuleData);
        const updatedBankData = isChecked ? updatedModuleData : [];
        setTPBankData(updatedBankData);
    };
    const updateCheck = (index, e, name) => {
        const isChecked = e.target.checked;
        // console.log(isChecked);

        // Update tpModuleData to reflect the checkbox change
        const updatedModuleData = fundData.map((item, i) => {
            if (index === i) {
                return { ...item, [name]: isChecked ? '1' : '0' };
            }
            return item;
        });

        setFundData(updatedModuleData);

        // Update tpBankData to include only checked items
        const updatedBankData = updatedModuleData.filter(item => item.ischecked === '1');
        setTPBankData(updatedBankData);
    };

    const handledownloadchange = (resp) => {
        setTPBankData([
            ...tpBankData,
            {
                tft_group: resp.tft_group, tft_account: resp.tft_account, tft_amount: resp.tft_amount, tft_srno: resp.tft_srno
                , tft_location: resp.tft_location, tft_type: resp.tft_type, tft_date: resp.tft_date
                , tft_ref_no: resp.tft_ref_no, tft_single_download: "1"
            }
        ]);
        setShowDownloadModal(true);
    }
    const handleChangeBankDetail = (value) => {
        setBankDetail(value);
        const bank = value.id.split('^');
    }
    const handleChangeUploadId = (value) => {
        setFilterUploadDocType(value);
        const bank = value.id.split('^');
        setFilterUploadDocCode(bank[1]);
    }

    const handleFileChange = (v) => {
        setNFile(v);
    }
    const handleDocumentUploadFileChange = (v) => {
        setNFileUploadDocument(v);
    }

    const uploadFile = () => {
        var msg = [], i = 0;
        $(".loader").show();
        const bank = bankDetail.id.split('^');
        var selectedFile = document.getElementById('uploadEntries').files[0];
        if (!bankDetail) {
            setMsgText('Please select from bank');
            setMsgBox(true);
        } else if (selectedFile === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else if ((selectedFile.name.split('.')).length > 2) {
            $('.loader').hide();
            setMsgText("(.) not allowed in file name.");
            setMsgBox(true);
        } else if (selectedFile.name.split('.')[1] !== "xlsx") {
            $('.loader').hide();
            setMsgText("File extension must be xlsx.");
            setMsgBox(true);
        } else if (selectedFile.size > 10 * 1024 * 1024) {  // 10 MB
            $('.loader').hide();
            setMsgText("Please select a file with in 10 MB size.");
            setMsgBox(true);
        } else {
            $(".loader").show();
            const obj = {
                sid: sid,
                pageright: "FUND_TRANSFER",
                uploadType: "uploadbankrefno",
                filename: nFile,
                tmp_from_bank_group: bank[9],
                tmp_from_bank_account: bank[8],
                tmp_account_number: bank[5],
                tmp_account_name: bank[3],
                tmp_ifdc: bank[6],
                tmp_bank_code: bank[7],
            }
            Common.uploadApi(JSON.stringify(obj), "uploadEntries", (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.error === "0") {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
                setNFile("");
                setShowUploadButton(!showUploadButton);
                setShowUploadDownloadModal(false);
            });
        }
    }
    const handleFinalUpload = () => {
        setMsgBoxUploadYN(true);
    }
    const uploadFileDocument = () => {
        $(".loader").show();
        setMsgBoxUploadYN(false);
        var msg = [], i = 0;
        var selectedFile = document.getElementById('uploadEntries').files[0];
        if (selectedFile === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else if ((selectedFile.name.split('.')).length > 2) {
            $('.loader').hide();
            setMsgText("(.) not allowed in file name.");
            setMsgBox(true);
        }
        else if (selectedFile.size > 10 * 1024 * 1024) {  // 10 MB
            $('.loader').hide();
            setMsgText("Please select a file with in 10 MB size.");
            setMsgBox(true);
        } else {
            const obj = {
                sid: sid,
                pageright: "FUND_TRANSFER",
                uploadType: "uploadDocumentFundTransfer",
                filename: nFileUploadDocument,
                location: hdrLocation,
                type: hdrType,
                srno: hdrSrno,
                docno: filterUploadDocCode,
                remark: acRemark,
                key: `transaction/${hdrLocation}-${hdrType}-${hdrSrno}-${filterUploadDocCode}-${Common.getYmdHis()}-${Common.getRandomString(10)}.${selectedFile.name.split('.')[1]}`,
            }
            Common.callApi(Common.apiAWS, [sid, "getUploadUrl", JSON.stringify(obj)], async (result) => {
                $('.loader').hide();
                console.log("this is obj", obj);
                const url = result;

                const resp = await Common.uploadFiletoAWSbucket(url, selectedFile);
                getUploadedDoc(`transaction/${hdrLocation}-${hdrType}-${hdrSrno}`);
                setNFile("");
                if (resp.ok && resp.status === 200) {
                    setMsgText("Uploaded Successfully ✅");
                    setMsgBox(true);
                } else {
                    setMsgText("Upload Failed ❌");
                    setMsgBox(true);
                }
            });

        }
    }
    const getUploadedDoc = (id) => {
        let obj = {
            id: id,
        }
        Common.callApi(Common.apiAWS, [sid, "listData", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (Array.isArray(resp) && resp.length > 0) {
                const formattedList = resp.map((item) => {
                    const parts = item.split("/");
                    const parts1 = parts[1].split("-");
                    return {
                        doc_location: parts1[0],
                        doc_type: parts1[1],
                        doc_srno: parts1[2],
                        doc_fileType: parts1[3],
                        doc_dateTime: parts1[4],
                        doc_randomId: parts1[5].split(".")[0],
                        doc_fileName: parts1[5],
                        doc_fullPath: item,
                    };
                });
                setUploadedDocList(formattedList);
            } else {
                setUploadedDocList([]);
            }
        });
    }
    const viewUploadedDocument = (fullpath) => {
        const obj = {
            key: fullpath
        }
        Common.callApi(Common.apiAWS, [sid, "viewData", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            window.open(resp, "_blank");
        })

    }
    const downloadUploadedDocument = (fullpath) => {
        const obj = {
            key: fullpath
        };
        Common.callApi(Common.apiAWS, [sid, "viewData", JSON.stringify(obj)], async (result) => {
            const resp = JSON.parse(result);
            const response = await fetch(resp);
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            const fileName = resp.split("/").pop();
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        });
    }
    const deleteUploadedDocument = (fullpath) => {
        let obj = {
            key: fullpath,
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno,
            docno: filterUploadDocCode,
        };
        Common.callApi(Common.apiAWS, [sid, "deleteData", JSON.stringify(obj)], async (result) => {
            getUploadedDoc(`transaction/${hdrLocation}-${hdrType}-${hdrSrno}`);
            setMsgText("Deleted Successfully.");
            setMsgBox(true);
        });
    }

    const handleChangeRadiotype = () => {
        setRadioType("U");
        setShowUploadButton(true);
        setShowUploadDownloadModal(true);
    }
    const handleTabChange = (k) => {
        setKey(k);
    }
    const handlebanknamechange = (e) => {
        setBankDetail();
        setFilterBankName(e.target.value);
    }


    const handleRejectPending = async () => {
        let confirmApprove = await showConfirm("Are you sure you want to change status?");
        if (!confirmApprove) return;
        const obj = {
            updatedStatus: requireApprovalOf,
            location: hdrLocation,
            type: hdrType,
            srno: hdrSrno
        }

        Common.callApi(Common.apiFundTransfer, [sid, "reject_to_pending", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setScrMode("");
            setMsgText(resp.message);
            setMsgBox(true);
            listFundData();
        });


    }
    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Fund Transfer</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>
                            <Row className='mt-10'>
                                <Col className='col-md-6 col-12'>
                                    <Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Check checked={radioType === "St"} onChange={() => setRadioType("St")} type='radio' label="Status" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            {
                                                userUploadRight.add === "1" ?
                                                    <Col>
                                                        <Form.Check checked={radioType === "U"} onChange={() => handleChangeRadiotype()} type='radio' label="Upload bank Refnumber" />
                                                    </Col>
                                                    : null
                                            }
                                            {/* <Col>
                                                <Form.Check checked={radioType === "Fa"} onChange={() => setRadioType("Fa")} type='radio' label="FA view" />
                                            </Col> */}

                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={filterLocation} onChange={(e) => setFilterLocation(e.target.value)}
                                            required>
                                            <option value="O">One</option>
                                            <option value="A">All</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                {filterLocation === 'O' ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={ftLocation}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleChangeRepLocation}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                </> : null}
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Transaction Type  <span className="text-danger">*</span></Form.Label>
                                        <Form.Select value={filterTranType} onChange={e => setFilterTranType(e.target.value)}
                                            required>
                                            <>
                                                {/* <option value="A">ALL</option> */}
                                                <option value="PP">Purchase Public</option>
                                                <option value="MT">Principle Module</option>
                                                {/* <option value="SP">Sale Public</option> */}
                                                <option value="PB">Purchase Bulk</option>
                                                {piFundProcess.add == '1' || piFundProcess.edit == '1' || piFundProcess.query == '1' ?
                                                    <option value="PI">Purchase Invoice</option>
                                                    : null
                                                }
                                            </>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {radioType === "S" ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={10} value={filterFromSrno} onChange={e => Common.validateNumValue(e.target.value, setFilterFromSrno)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={10} value={filterToSrno} onChange={e => Common.validateNumValue(e.target.value, setFilterToSrno)} />
                                        </Form.Group>
                                    </Col>
                                </> : radioType === "B" ? <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={10} value={filterbanklocation} onChange={e => Common.validateNumValue(e.target.value, setFilterBankLocation)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={10} value={filterBankType} onChange={e => Common.validateAlpValue(e.target.value, setFilterBankType)} />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Srno<span className="colorThemeRed">*</span></Form.Label>
                                            <Form.Control type='text' maxLength={10} value={filterBankSrno} onChange={e => Common.validateNumValue(e.target.value, setFilterBankSrno)} />
                                        </Form.Group>
                                    </Col>
                                </> :
                                    radioType === "St" ? <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Status<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Select value={filterStatus} onChange={(e) => handleStatus(e)} required >
                                                    <option value="A">All</option>
                                                    <option value="PE">Pending for Export</option>
                                                    <option value="MK">Pending Checker Approval</option>
                                                    <option value="CK">Pending BM Approval</option>
                                                    <option value="BM">Pending AM Approval</option>
                                                    <option value="AM">Pending ZM Approval</option>
                                                    <option value="ZM">Pending CO Approval</option>
                                                    <option value="CO">Pending CFO Approval</option>
                                                    <option value="PT">Pending Transfer</option>
                                                    <option value="R">Rejected</option>
                                                    <option value="D">Done</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Search <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type='text' placeholder='Search By Party Name ' maxLength="100" value={searchFilter}
                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSearchFilter)}
                                                />
                                            </Form.Group>
                                        </Col></>
                                        : radioType === "D" ? <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={filterFromDate}
                                                        onChange={(date) => setFilterFromDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={filterToDate}
                                                        onChange={(date) => setFilterToDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </> : null}
                                <Row>&nbsp;</Row>
                                <Row>
                                    <Col>
                                        {
                                            userRight.query === "1" && (radioType === "St" || radioType === "S" || radioType === "D" || radioType === "B") ?
                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listFundData()}>List</Button> : null
                                        }
                                        &nbsp;
                                        {
                                            radioType === 'St' && filterStatus === 'PT' && fundData.length > 0 && isDownload === true && userDownloadRight.query === "1" ?
                                                <>
                                                    &nbsp;< Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => setShowDownloadModal(true)}>Download Bank File</Button>
                                                </>
                                                : null
                                        }
                                        &nbsp;
                                    </Col>
                                </Row>
                                <Row>&nbsp;</Row>
                                <Row>
                                    <Table responsive bordered striped>
                                        <thead>
                                            <tr>
                                                <th>
                                                    {radioType === 'St' && filterStatus === "PT" &&
                                                        <Form.Check
                                                            type='checkbox'
                                                            label=""
                                                            checked={allChecked}
                                                            onChange={handleSelectAll}
                                                        />
                                                    }

                                                </th>
                                                <th>Request Date</th>
                                                {(filterStatus == "PT" || filterStatus == "D") && <th>Approve Date</th>}
                                                <th>Location</th>
                                                <th>Type</th>
                                                <th>Srno</th>
                                                <th>Transaction Date</th>
                                                <th>Amount</th>
                                                <th>Status</th>
                                                {/* <th>&nbsp;</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                fundData.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>
                                                                {radioType === 'St' && filterStatus === "PT" ?
                                                                    <>
                                                                        <span style={{ display: 'inline-block' }}>
                                                                            <Form.Check
                                                                                type='checkbox'
                                                                                label=""
                                                                                checked={item.ischecked === '1'}
                                                                                name="ischecked"
                                                                                onChange={(e) => updateCheck(index, e, "ischecked")}
                                                                            />
                                                                        </span>
                                                                        &nbsp;
                                                                    </>
                                                                    : null
                                                                }
                                                                <span onClick={() => fillViewForm(item)} className='pointer colorThemeBlue'>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            </td>
                                                            <td>{item.tft_maker_timestampdmy}</td>
                                                            {(filterStatus == "PT" || filterStatus == "D") && <td>{item.tft_approve_timestampdmy}</td>}
                                                            <td
                                                                className={item.tft_isref_updated * 1 === 1 ? 'bg-success text-white' : ""}
                                                            >
                                                                {item.location_name}
                                                            </td>
                                                            <td
                                                                className={item.tft_isref_updated * 1 === 1 ? 'bg-success text-white' : ""}
                                                            >
                                                                {item.tft_type}
                                                            </td>
                                                            <td
                                                                className={item.tft_isref_updated * 1 === 1 ? 'bg-success text-white' : ""}
                                                            >
                                                                {item.tft_srno}
                                                            </td>
                                                            <td>{item.tft_datedmy}</td>
                                                            <td>{item.tft_amount}</td>
                                                            <td>{
                                                                (item.tft_last_approval === "MK" && item.tft_status === "P" && item.tft_export === "0") ? "Pending for Export" :
                                                                    (item.tft_last_approval === "MK" && item.tft_status === "P" && item.tft_export === "1") ? "Pending for checker Approval" :
                                                                        (item.tft_last_approval === "CK" && item.tft_status === "P") ? (item.tft_type === "PI" ? "Pending for Account Head Approval" : "Pending for Branch Approval") :
                                                                            (item.tft_last_approval === "BM" && item.tft_status === "P") ? "Pending for Area Manager Approval" :
                                                                                (item.tft_last_approval === "AM" && item.tft_status === "P") ? "Pending for zone Approval" :
                                                                                    (item.tft_last_approval === "ZM" && item.tft_status === "P") ? (item.tft_type === "PI" ? "Pending for CFO approvel" : "Pending for compliance Approval") :
                                                                                        (item.tft_last_approval === "CO" && item.tft_status === "P") ? "Pending for CFO Approval" :
                                                                                            (item.tft_status === "A" && item.tft_bank_file_downloaded === "0") ? "Approved" :
                                                                                                (item.tft_status === "A" && item.tft_bank_file_downloaded === "1") ? "Bank File Downloaded" :
                                                                                                    (item.tft_status === "R") ? "Rejected" : null}</td>
                                                            {/* <td>{item.tft_status == "A" && userDownloadRight.query === "1" && <span><Badge bg='success' className="handCursor" onClick={() => handledownloadchange(item)}>Download bank file</Badge></span>}</td> */}
                                                        </tr>
                                                        <tr key={`hi+${index}`} >
                                                            <td colSpan={15}>
                                                                {(filterStatus == "D") && <>Downloaded by : {item.um_id} , Download Timestamp : {item.tft_download_timestamp}</>} Party : {item.tft_group} {item.tft_account} {item.mvli_ledger_name} , Bank IFSC : {item.mvli_bank_ifsc_party}, Acc No : {item.mvli_account_num} , Refno : {item.full_ref_no}
                                                            </td >
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Row>
                            </Row>
                            <Row>&nbsp;</Row>

                        </> :
                        <Row>
                            <Row>
                                <Col>
                                    <Button variant='danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (userRight.edit === "1" && scrMode === 'Q' && lastApproval === "MK" && isEditable === "Y") ? <>
                                            <Button variant="success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ? <>
                                            <Button variant="success" className='buttonStyle' size="sm" onClick={() =>
                                                saveData()}>Save</Button>&nbsp;
                                        </> : null
                                    }
                                    &nbsp;
                                    {(userRight.query === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {statusApprovedPending === "P" || (statusApprovedPending === "A") ?
                                        <>
                                            {(userRight.delete || isexport === "0") && scrMode !== 'E' && showRejectButton === "1" ?
                                                <>
                                                    <Button variant='danger' size='sm' className='buttonStyle' onClick={() => handleRejectFund()}>Reject</Button> &nbsp;
                                                </>
                                                : null} &nbsp;
                                            &nbsp;
                                        </>
                                        : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Serial Number : <b>{hdrSrno}</b></Form.Label>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{locationName} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Type : <b>{hdrType == 'PP' ? "Purchase Public" : hdrType == 'PB' ? "Purchase Bulk" : hdrType == 'MT' ? "Principle Module" : null} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='ppCharges'>
                                    <span><b>Forex Total (INR): {hdrAmount}</b></span>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Group <span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control disabled={true} placeholder='Group' type='text' maxLength={250} value={nGroup}
                                                    onChange={e => Common.validateNumValue(e.target.value, setNGroup)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Account <span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control disabled={true} placeholder='Account' type='text' maxLength={250} value={nAccount}
                                                    onChange={e => Common.validateNumValue(e.target.value, setNAccount)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Party Name <span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Control disabled={true} placeholder='party name' type='text' maxLength={250} value={ledgerName}
                                                    onChange={e => Common.validateAlpNumValue(e.target.value, setLedgerName)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col className="col-md-3 col-6">
                                                <Form.Group>
                                                    <Form.Label>Refnumber <span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control disabled={true} placeholder='Account' type='text' maxLength={250} value={refNum}
                                                        onChange={e => Common.validateNumValue(e.target.value, setRefnum)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className="col-md-3 col-6">
                                                <Form.Group>
                                                    <Form.Label>FA Number <span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control disabled={true} placeholder='' type='text' maxLength={250} value={faNumber}
                                                        onChange={e => Common.validateNumValue(e.target.value, setFaNumber)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className="col-md-3 col-6">
                                                <Form.Group>
                                                    <Form.Label>GB Number <span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control disabled={true} placeholder='' type='text' maxLength={250} value={gbNumber}
                                                        onChange={e => Common.validateNumValue(e.target.value, setGbNumber)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col className="col-md-6 col-12">
                                                <span>Paying to : <b>{payingToId}  {payingToName} </b></span>
                                            </Col>

                                        </Row>
                                        <Row>

                                            <Col className="col-md-3 col-6">
                                                <Form.Label>Bank Name</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={ldgAllBank}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchAllBankPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleAllBankChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Col>
                                            <Col className="col-md-3 col-6">
                                                <Form.Group>
                                                    <Form.Label>Account Number <span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nAccountNo}
                                                        onChange={e => Common.validateAlpNumValue(e.target.value, setNAccountNo)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className="col-md-3 col-6">
                                                <Form.Group>
                                                    <Form.Label>IFSC No <span className="colorThemeRed">*</span></Form.Label>
                                                    <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={nIfscCode}
                                                        onChange={e => Common.validateAlpNumValue(e.target.value, setNIfscCode)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>


                                        {isRefUpdated === "1" &&
                                            <Row>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Full Reference Number <span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={fullRefno}
                                                            onChange={e => Common.validateAlpNumValue(e.target.value, setFullRefno)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Upadted timestamp <span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={fullRefnoTimestamp}
                                                            onChange={e => Common.validateAlpNumValue(e.target.value, setFullRefnoTimestamp)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Group>
                                                        <Form.Label>Upadted Srno  <span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control disabled={scrMode === "Q"} placeholder='Account' type='text' maxLength={250} value={refUpdatedSrno}
                                                            onChange={e => Common.validateAlpNumValue(e.target.value, setRefUpdatedSrno)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        }
                                    </Row>
                                </Tab>
                                <Tab eventKey="DETAILS" title="Details">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Table responsive bordered striped>
                                            <thead>
                                                <tr>
                                                    <th>Product</th>
                                                    <th>Isd Code</th>
                                                    <th>Isd Name</th>
                                                    <th>Denomination</th>
                                                    <th>Quantity</th>
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>USD Rate</th>
                                                    <th>USD Amount</th>
                                                    <th>Prefix</th>
                                                    <th>From</th>
                                                    <th>To</th>
                                                    {
                                                        <>
                                                            <th>Agent</th>
                                                            <th>Commission Type</th>
                                                            <th>Commission</th>
                                                            <th>Commission Value</th>
                                                        </>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pProductList.map((item, index) => (
                                                        <>
                                                            <tr key={index}>
                                                                <td>{item.prd_product}</td>
                                                                <td>{item.prd_isd}</td>
                                                                <td>{item.isd_name}</td>
                                                                <td>{item.prd_deno}</td>
                                                                <td>{item.prd_qty}</td>
                                                                <td>{item.prd_rate}</td>
                                                                <td>{item.prd_amount}</td>
                                                                <td>{item.prd_usd_rate}</td>
                                                                <td>{item.prd_usd_amount}</td>
                                                                <td>{item.prd_prefix}</td>
                                                                <td>{item.prd_from}</td>
                                                                <td>{item.prd_to}</td>
                                                                {
                                                                    <>
                                                                        {
                                                                            item.prd_agent_group == "0" ?
                                                                                <td></td> :
                                                                                <td>{item.prd_agent_group + " " + item.prd_agent_ledger + " " + item.prd_agent_name}</td>
                                                                        }
                                                                        <td>{item.prd_commission_type === "P" ? "Paisa"
                                                                            : item.prd_commission_type === "R" ? "Percentage"
                                                                                : item.prd_commission_type === "F" ? "Flat" : ""}</td>
                                                                        <td>{item.prd_commission * 1 > 0 ? item.prd_commission : ""}</td>
                                                                        <td>{item.prd_commission_value * 1 > 0 ? item.prd_commission_value : ""}</td>
                                                                    </>
                                                                }
                                                            </tr>
                                                            {
                                                                item.prd_product === "EVTM" ? <>
                                                                    <tr key={index + '1'} >
                                                                        <td colspan="13" >
                                                                            Br Surr : {item.prd_stb_date_dmy}&nbsp;{item.prd_stb_type}-{item.prd_stb_srno}&nbsp;
                                                                            {
                                                                                1 * item.prd_stc_srno > 0 ? <>
                                                                                    &nbsp;Corp Sett : {item.prd_stc_date_dmy}&nbsp;{item.prd_stc_type}-{item.prd_stc_srno}&nbsp;
                                                                                </> : null
                                                                            }

                                                                        </td>
                                                                    </tr>
                                                                </> : null
                                                            }
                                                        </>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                {userDocUploadRight.query === "1" &&
                                    <Tab eventKey="DOCUMENTS" title="Documents">
                                        <Row>
                                            <Row>
                                                <Col className="col-md-3 col-6">
                                                    <Form.Label>Select ID type</Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={filterUploadDocType}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchAllIds(search, "FT")}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(e) => handleChangeUploadId(e)}
                                                    >
                                                    </AsyncSelect>
                                                </Col>
                                                <Col className='col-md-3 col-3'>
                                                    <Form.Group controlId='uploadEntries'>
                                                        <Form.Label>File* (MAX 10MB)</Form.Label>
                                                        <Form.Control type='file' value={nFileUploadDocument} onChange={e => handleDocumentUploadFileChange(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Button style={{ marginTop: "33px" }} variant='primary' className='buttonStyle' size='sm' onClick={() => handleFinalUpload()}>Submit</Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Table responsive bordered striped>
                                                    <thead>
                                                        <tr>
                                                            <th>File Type</th>
                                                            {/* <th>Document Type</th> */}
                                                            <th>File Name</th>
                                                            <th>&nbsp;</th>
                                                            <th>&nbsp;</th>
                                                            <th>&nbsp;</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {uploadedDocList.map((doc, index) => (
                                                            <tr key={index}>
                                                                <td>{doc.doc_fileType}</td>
                                                                {/* <td>{doc.}</td> */}
                                                                <td>{doc.doc_fileName}</td>
                                                                <td>
                                                                    <span onClick={() => viewUploadedDocument(doc.doc_fullPath)} className='pointer colorThemeBlue'>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <Badge bg="secondary" className="handCursor" onClick={() => downloadUploadedDocument(doc.doc_fullPath)}><FontAwesomeIcon icon={faDownload} /></Badge>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <Badge bg="secondary" className="handCursor" onClick={() => deleteUploadedDocument(doc.doc_fullPath)}><FontAwesomeIcon icon={faTrash} /></Badge>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Row>
                                        </Row>
                                    </Tab>
                                }
                            </Tabs>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {userRight.add === "1" && isexport === "0" &&
                                        <>
                                            <Button variant='success' size='sm' className='buttonStyle' onClick={() => handleExportFund()}>Export</Button>&nbsp;
                                        </>
                                    }
                                </Col>
                                <Col>



                                    {
                                        userDownloadRight.query === "1" && statusApprovedPending === "R" ?
                                            <Button variant='success' size='sm' className='buttonStyle btn btn-danger btn-sm' onClick={() => handleRejectPending()}>Reject to Pending</Button>
                                            : null
                                    }

                                    {
                                        userDownloadRight.query === "1" ?
                                            <>
                                                &nbsp;< Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => updateBankDetails()}>Update Bank Details</Button>
                                            </>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>
                                &nbsp;
                            </Row>
                            <Row>
                                <Col>
                                    {statusApprovedPending === "P" && isexport === "1"  && (filterTranType=='PB' || filterTranType=='MT'||filterTranType=='PP' ) ?
                                        <>
                                            {((checkerApprovalRight.edit === "1" && requireApprovalOf === "CK") || (bMApprovalRight.edit === "1" && requireApprovalOf === "BM")
                                                || (zMApprovalRight.edit === "1" && requireApprovalOf === "ZM") || (coApprovalRight.edit === "1" && requireApprovalOf === "CO")
                                                || (amApprovalRight.edit === "1" && requireApprovalOf === "AM")
                                                || (cfoApprovalRight.edit === "1" && requireApprovalOf === "CFO")) && scrMode !== 'E' ?
                                                <>
                                                    <Button variant='warning' size='sm' className='buttonStyle' onClick={() => handleSendBacktobranch()}>Send Back To Branch</Button> &nbsp;
                                                    <Button variant='success' size='sm' className='buttonStyle' onClick={() => handleApproveFund()}>Approve</Button>&nbsp;
                                                </>
                                                : null} &nbsp;
                                            &nbsp;
                                        </>
                                        : null}
                                    {/* {isDownloadBankFile === "1" && userDownloadRight.query === "1" ?
                                        < Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => setShowDownloadModal(true)}>Download Bank File</Button>
                                        : null} */}
                                </Col>


                                <Col>
                                    {statusApprovedPending === "P" && isexport === "1" && filterTranType=='PI' ? 
                                        <>
                                            {((rightCkPi.edit === "1" && requireApprovalOf === "CK")
                                                || (rightZmPi.edit === "1" && requireApprovalOf === "ZM") 
                                                || (cfoApprovalRight.edit === "1" && requireApprovalOf === "CFO")) && scrMode !== 'E' ?
                                                <>
                                                    <Button variant='warning' size='sm' className='buttonStyle' onClick={() => handleSendBacktobranch()}>Send Back To Branch</Button> &nbsp;
                                                    <Button variant='success' size='sm' className='buttonStyle' onClick={() => handleApproveFund()}>Approve</Button>&nbsp;
                                                </>
                                                : null} &nbsp;
                                            &nbsp;
                                        </>
                                        : null}
   
                                </Col>
                            </Row>
                        </Row>
                }
            </Container >
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Modal size='lg' show={showDownloadModal} onHide={() => setShowDownloadModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Bank Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Select bank name to upload file<span className="colorThemeRed">*</span></Form.Label>
                                <Form.Select value={filterBankName} onChange={e => handlebanknamechange(e)}>
                                    <option value="AXIS">AXIS</option>
                                    <option value="ICICI">ICICI</option>
                                    <option value="HDFC">HDFC</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>From Bank<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={bankDetail}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchBankDetailsPicklist(search, locationCode, filterBankName)} // location = 1 , 2                                    
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={(e) => handleChangeBankDetail(e)}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDownloadModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={downloadBankFile}>
                        Download Bank Files
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* ******************************************************************************************************************* */}
            <Modal size='lg' show={showUploadDownloadModal} onHide={() => setShowUploadDownloadModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Bank Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Select bank name to upload file<span className="colorThemeRed">*</span></Form.Label>
                                <Form.Select value={filterBankName} onChange={e => handlebanknamechange(e)}>
                                    <option value="AXIS">AXIS</option>
                                    <option value="ICICI">ICICI</option>
                                    <option value="HDFC">HDFC</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>From Bank<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={bankDetail}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={(search) => Picklist.fetchBankDetailsPicklist(search, locationCode, filterBankName)}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={(e) => handleChangeBankDetail(e)}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        {
                            (userUploadRight.add === '1' && showUploadButton === true) ?
                                <>
                                    <Col className='col-md-3 col-3'>
                                        <Form.Group controlId='uploadEntries'>
                                            <Form.Label>File* (MAX 10MB)</Form.Label>
                                            <Form.Control type='file' value={nFile} onChange={e => handleFileChange(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </>
                                : null
                        }
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowUploadDownloadModal(false)}>
                        Close
                    </Button>
                    <Button style={{ marginTop: "33px" }} variant='primary' className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>
                </Modal.Footer>
            </Modal>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>

            <DialogYesNo
                isOpen={isMsgBoxYN}
                onYes={handleYes}
                onNo={handleNo}
            >
                {msgTextYN}
            </DialogYesNo>

            {/* ************************************************************************************************ */}
            <Modal size='lg' show={isMsgBoxUploadYN} onHide={() => setMsgBoxUploadYN(false)}>
                <Modal.Body>
                    <Row>
                        <Form.Group>
                            <Form.Label>Remark<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Control type='text' maxLength={255} value={acRemark} onChange={e => Common.validateAlpNumValue(e.target.value, setAcRemark)} />
                        </Form.Group>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size='sm' onClick={() => setMsgBoxUploadYN(false)}>
                        Close
                    </Button>
                    <Button style={{ marginTop: "33px" }} variant='primary' className='buttonStyle' size='sm' onClick={() => uploadFileDocument()}>Submit</Button>
                </Modal.Footer>
            </Modal>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Fund_transfer
